import { request, getuserVid } from './request'
import env from '@/config'
import { getHeaderSignature, getUnisysid } from '@/utils/utils'
import VueCookies from 'vue-cookies'

function selectChatList(params) {
    return request({
        url: '/web/api/ai/selectChatList',
        method: 'GET',
        params: params
    })
}

function updateChatTitle(params) {
    return request({
        url: '/web/api/ai/updateTitle',
        method: 'GET',
        params: params
    })
}

function deleteChat(params) {
    return request({
        url: '/web/api/ai/deleteChat',
        method: 'GET',
        params: params
    })
}

function getChatHistory(params) {
    return request({
        url: '/web/api/ai/history',
        method: 'GET',
        params: params
    })
}

function deleteChatMsg(params) {
    return request({
        url: '/web/api/ai/deleteChatMsg',
        method: 'GET',
        params: params
    })
}

function stopStream(params) {
    return request({
        url: '/web/api/ai/stopStream',
        method: 'GET',
        params: params
    })
}


async function streamChat(options, _isRetry = false) {
    let abortController = null
    let reader = null

    try {
        // 1. 准备请求参数
        const { TOKEN, TIMESTAMP, NONESTR, SIGNATURE, VERSION, visitorId } = await getHeaderSignature()
        const uniSysId = options.uniSysId || getUnisysid()

        abortController = new AbortController()

        const requestBody = {
            modelId: options.modelId,
            uniSysId: uniSysId,
            userMessage: {
                chatId: options.chatId || null,
                text: options.text,
                enableThinking: options.enableThinking || false
            }
        }

        if (options.msgId) {
            requestBody.userMessage.msgId = options.msgId
        }

        if (options.visitId) requestBody.visitId = options.visitId
        if (options.menuId) requestBody.menuId = options.menuId

        // 2. 发送请求
        const response = await fetch(`${env.ApiUrl}/web/api/ai/stream`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'text/event-stream',
                'vi': visitorId || options.visitId || '',
                'tk': TOKEN,
                'ts': TIMESTAMP,
                'ns': NONESTR,
                'sg': SIGNATURE,
                'vn': VERSION,
                'unisysid': uniSysId
            },
            body: JSON.stringify(requestBody),
            signal: abortController.signal
        })

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        // 3. 获取流式读取器
        reader = response.body.getReader()

        // 4. 检查首块数据是否包含 2009 错误码（访客信息过期）
        const firstReadResult = await reader.read()

        if (!firstReadResult.done && firstReadResult.value) {
            const decoder = new TextDecoder()
            const firstChunk = decoder.decode(firstReadResult.value, { stream: true })

            if (firstChunk.includes('"code":2009') || firstChunk.includes('"code": 2009')) {
                try {
                    reader.releaseLock()
                } catch (e) {
                }

                if (!_isRetry) {
                    VueCookies.remove('visitorRes')
                    try {
                        await getuserVid()

                        const newVisitorRes = VueCookies.get('visitorRes')
                        const newVisitorId = newVisitorRes?.visitorId || ''


                        // 使用新的 visitId 重试请求
                        return await streamChat({
                            ...options,
                            visitId: newVisitorId
                        }, true)
                    } catch (e) {
                        console.error('获取访客信息失败:', e)
                        return { success: false, error: '访客信息已过期，请刷新页面重试' }
                    }
                }
                return { success: false, error: '访客信息已过期，请刷新页面重试' }
            }

            // 不是 2009，需要把首块数据传回去
            // 创建一个新的 ReadableStream，先输出首块数据，再接续原始流
            const originalReader = reader
            const combinedStream = new ReadableStream({
                async start(controller) {
                    // 先推送首块数据
                    controller.enqueue(firstReadResult.value)
                },
                async pull(controller) {
                    try {
                        const { done, value } = await originalReader.read()
                        if (done) {
                            controller.close()
                        } else {
                            controller.enqueue(value)
                        }
                    } catch (e) {
                        // 如果是中止错误，正常关闭流
                        if (e.name === 'AbortError' || e.message?.includes('aborted') || e.message?.includes('BodyStreamBuffer was aborted')) {
                            controller.close()
                        } else {
                            controller.error(e)
                        }
                    }
                },
                cancel() {
                    try {
                        originalReader.cancel()
                    } catch (e) {
                        // 忽略取消时的错误
                    }
                }
            })

            reader = combinedStream.getReader()
        }

        return { success: true, response, reader, abortController }

    } catch (error) {
        if (error.name === 'AbortError') {
            return { success: false, error: '请求已中止', aborted: true }
        }

        if (error.message && (
            error.message.includes('network error') ||
            error.message.includes('ERR_INCOMPLETE_CHUNKED_ENCODING') ||
            error.message.includes('Failed to fetch')
        )) {
            console.warn('流式传输网络错误，可能已接收部分数据:', error.message)
            return {
                success: false,
                error: error.message || '网络错误'
            }
        }

        return { success: false, error: error.message || '网络错误' }
    } finally {
        // 注意：不要在这里 releaseLock/cancel reader
        // reader 的生命周期由 utils/调用方管理（否则会打断解析）
        abortController = null
    }
}

export default {
    selectChatList,
    updateChatTitle,
    deleteChat,
    getChatHistory,
    streamChat,
    deleteChatMsg,
    stopStream
}

